import { Tag, Tooltip, type TagProps } from 'antd';
import type { ReactNode } from 'react';

export interface BaseTagProps extends TagProps {
  tooltip?: ReactNode;
}

/** 标签只处理统一外观和可选说明，不内置任何业务枚举。 */
export default function BaseTag({
  tooltip,
  className,
  ...props
}: BaseTagProps) {
  const tag = (
    <Tag
      {...props}
      className={['base-tag', className].filter(Boolean).join(' ')}
    />
  );
  return tooltip ? <Tooltip title={tooltip}>{tag}</Tooltip> : tag;
}
